import React from "react";

import { Network } from "../../services/NetworkApi";
import { Button } from "../../UI/Button";
import { Box } from "../../UI/Box";
import { ReadOnlyWrapper } from "../ReadOnlyWrapper";
import { WrapperWithTitle } from "../WrapperWithTitle";
import { TextField } from "../../UI/TextField";
import useAuth from "../../routes/login/AuthContext";
interface IProps {
  l2?: Network | null;
  updateHandler: (key: string, value: string) => Promise<void>;
  isDisabled?: boolean;
}

export const GenderSectionExplaner: React.FC<IProps> = (props) => {
  const { isSuperAdminRead } = useAuth();
  const [isLoading, setIsLoading] = React.useState(false);
  const [explainer, setExplainer] = React.useState(
    props.l2?.genderNetworkSettingsTransport.genderSelectionExplainer || ""
  );

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setExplainer(e.target.value);
  };

  React.useEffect(() => {
    if (!props.l2?.genderNetworkSettingsTransport.genderSelectionExplainer) return;

    setExplainer(props.l2?.genderNetworkSettingsTransport.genderSelectionExplainer);
  }, [props.l2?.genderNetworkSettingsTransport.genderSelectionExplainer]);

  const handleUpdate = async () => {
    setIsLoading(true);
    await props.updateHandler("genderSelectionExplainer", explainer);
    setIsLoading(false);
  };

  return (
    <WrapperWithTitle title="What explainer language would you like to display to users for this section?">
      <TextField value={explainer} onChange={handleChange}  isDisabled={props.isDisabled}/>
      <Box mt={1}>
        <ReadOnlyWrapper>
          <Button isLoading={isLoading} appearance="primary" onClick={handleUpdate} isDisabled={isSuperAdminRead() || props.isDisabled}>
            Update
          </Button>
        </ReadOnlyWrapper>
      </Box>
    </WrapperWithTitle>
  );
};
